import React from "react";
import data from "../static/info/data";

export default function Footer() {
  return (
    <>
      <div className="footer p-2">
        <center>
          <div class="social-media">
            <p className="text-xl md:text-2xl">Find me on:</p>
            <div className="flex justify-center gap-6 sm:gap-10">
              {data.socialLinks.map((item, index) => (
                <a key={index} href={item.url} target="_blank">
                  <i
                    class={item.iconClass + " text-xl sm:text-2xl"}
                    aria-hidden="true"
                  ></i>
                </a>
              ))}
            </div>
          </div>
        </center>
        <hr />
        <footer>
          <p className="text-base">Made with ❤️ by Rushi Gandhi</p>
        </footer>
      </div>
    </>
  );
}
